import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const BENEFIT_HISTORY_LOADING = 'BENEFIT_HISTORY_LOADING'
export const BENEFIT_HISTORY_SUCCESS = 'BENEFIT_HISTORY_SUCCESS'
export const BENEFIT_HISTORY_FAILED = 'BENEFIT_HISTORY_FAILED'

export const fetchBenefitHistory = (depId, benefitType) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/benefits/${depId}/${benefitType}/history`,
        prefix: 'BENEFIT_HISTORY'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/benefitHistoryActions.js